import React, { useState, useEffect } from "react";
import { Button, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { COLORS } from "../../utils/colors";
import CustomSnackbar from "../../components/CustomSnackbar";

const AdminTable = ({ partnerSelfSignUps }) => {
  const [snackbar, setSnackbar] = useState({ message: "", variant: "" });

  console.log("All partnerSelfSignUps:", partnerSelfSignUps);
  const navigate = useNavigate();
  let counter = 1;
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredTransactions, setFilteredTransactions] = useState(partnerSelfSignUps);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  useEffect(() => {
    // Update filteredTransactions whenever transactions or searchTerm changes

    const filtered = partnerSelfSignUps
      .filter((signup) => {
        const { idProduct, firstName, lastName, email, phone, createdOnUTC, idPartnerCompany, idPartner } = signup;
        const searchString = searchTerm.toLowerCase();
        return (
          idProduct.name.toLowerCase().includes(searchString) ||
          `${firstName} ${lastName}` ||
          email.toLowerCase().includes(searchString) ||
          phone.toLowerCase().includes(searchString) ||
          new Date(createdOnUTC).toLocaleDateString().includes(searchString) ||
          (idPartnerCompany &&
            `${idPartnerCompany.name} ${idPartnerCompany.partnerType} ${JSON.stringify(idPartnerCompany.billing)}`
              .toLowerCase()
              .includes(searchString)) ||
          (idPartner && `${idPartner.firstName} ${idPartner.lastName}`.toLowerCase().includes(searchString))
        );
      })
      .sort((a, b) => new Date(b.createdOnUTC) - new Date(a.createdOnUTC));
    setFilteredTransactions(filtered);
  }, [partnerSelfSignUps, searchTerm]);

  return (
    <>
      <TableContainer
        sx={{
          width: "fit-content",
          maxWidth: "calc(100vw - 200px)",
          margin: "0 auto",
          overflowX: "auto",
          "&::-webkit-scrollbar": {
            height: "8px"
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
            borderRadius: "4px"
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#888",
            borderRadius: "4px",
            "&:hover": {
              background: "#555"
            }
          }
        }}
      >
        <TextField
          label="Search"
          variant="outlined"
          fullWidth
          value={searchTerm}
          onChange={handleSearchChange}
          sx={{ marginBottom: 2, maxWidth: "800px" }}
        />
        <Table
          sx={{
            minWidth: 650,
            borderCollapse: "separate",
            "td, th": { borderBottom: "none" },
            th: { fontSize: "18px" }
          }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Product</TableCell>
              <TableCell>Customer</TableCell>
              <TableCell>Created</TableCell>
              <TableCell>Partner Company</TableCell>
              <TableCell>Submitted By</TableCell>
              <TableCell>Price</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredTransactions.map((selfsignup) => {
              const {
                createdOnUTC,
                idProduct,
                firstName,
                lastName,
                email,
                phone,
                idPartnerCompany,
                idPartner,
                stripeAmount
              } = selfsignup;
              return (
                <TableRow
                  //   onClick={() => navigate(`/transaction/${selfsignup._id}`)}
                  key={selfsignup._id}
                  sx={{
                    boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
                    "&:hover": { cursor: "pointer" }
                  }}
                >
                  <TableCell scope="row">{counter++}</TableCell>
                  <TableCell scope="row">{idProduct.name}</TableCell>
                  <TableCell scope="row">
                    <>
                      {firstName} {lastName}
                      <br />
                      {email}
                      <br />
                      {phone}
                    </>
                  </TableCell>
                  <TableCell>{new Date(createdOnUTC).toLocaleDateString()}</TableCell>
                  <TableCell>{idPartnerCompany.name}</TableCell>
                  <TableCell>{idPartner ? `${idPartner.firstName} ${idPartner.lastName}` : ""}</TableCell>
                  <TableCell>
                    ${stripeAmount / 100 ?? 0} {idProduct.type === "onceoff" ? "" : "/ per month"}{" "}
                  </TableCell>
                  {/* <TableCell>
                    <div className="flex gap-2">
                      <Button
                        size="small"
                        variant="contained"
                        sx={{ backgroundColor: COLORS.priorityBlue.hex }}
                      >
                        View
                      </Button>
                    </div>
                  </TableCell> */}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {snackbar && <CustomSnackbar {...snackbar} />}
    </>
  );
};

export default AdminTable;
